var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkGxMeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #02222b;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 5px;\n      }\n\n      .cls-3 {\n        fill: #fa974f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.6,5h82.9c3.7,0,6.7,3.1,6.7,6.9v76.2c0,3.8-3,6.9-6.7,6.9H8.6c-3.7,0-6.7-3.1-6.7-6.9V11.9c-.1-3.8,2.9-6.9,6.7-6.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 49.9,
    cy: 50,
    r: 34.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.9,24.3l-19,28.8c-.3.3,0,.7.3.7l18.3-2c.3,0,.7.3.7.7l-7.5,22.9c0,.7.7.7,1,.3l25.2-33.7c.3-.3,0-.7-.3-.7l-19.9,3.3c-.3,0-.7-.3-.7-.7l2.6-19.3c.3-.7-.3-.7-.7-.3h0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGxMeter);
export default __webpack_public_path__ + "static/media/dark-gxMeter.6130d71cd5e48b147196d13eb709b2de.svg";
export { ForwardRef as ReactComponent };